var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-blog-notes",style:(_vm.box)},[_c('div',{class:_vm.container},[(!!_vm.note)?_c('div',{staticClass:"editor-content",domProps:{"innerHTML":_vm._s(_vm.note)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }